import { useRoomMapping } from './useRoomMapping';
import { useSelectParticipant } from './useSelectParticipant';

export const useDragAndDrop = () => {
  const { deselectParticipant, selectedParticipants } = useSelectParticipant();
  const { updateRoomMapping } = useRoomMapping();

  const dragParticipant = (event) => {
    event.preventDefault();
  };

  const dropParticipant = (event) => {
    event.stopPropagation();

    const participantId = event.dataTransfer.getData('text/plain');
    const roomIdentifier = event.currentTarget.dataset.roomIdentifier;

    // doing a group drop! And we want to deselect them when they're dropped.
    if (selectedParticipants.length > 0) {
      selectedParticipants.map((id) => {
        updateRoomMapping(id, roomIdentifier);
        deselectParticipant(id);
      });
      return;
    }

    updateRoomMapping(participantId, roomIdentifier);
  };

  return {
    dragParticipant,
    dropParticipant,
  };
};
